import { render, staticRenderFns } from "./MasterListIndex.vue?vue&type=template&id=3bed166c&scoped=true&"
import script from "./MasterListIndex.vue?vue&type=script&lang=js&"
export * from "./MasterListIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed166c",
  null
  
)

export default component.exports